export const inputWithPickerTheme = {
   light: {
      errorTextColor: 'text-red-800',
      errorBorderColor: 'border-red-400',
      hrLineBgColor: 'bg-gray-300',
      inputTextColor: 'text-gray-900',
      inputBorderColor: 'border-gray-300',
      inputDisableBgColor: 'bg-gray-100',
      focusRingColor: 'ring-primary-100',
      focusBorderColor: 'border-primary-300',
      pickerBgDisabledColor: 'bg-gray-50',
      disabledTextColor: 'text-gray-500'
   },
   dark: {}
}
